import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { TextField } from "@backstage/ui";
import { buildProjectId } from "@internal/backstage-plugin-gcp-project-approvals-common";

const MAX_PROJECT_ID_LENGTH = 30; // GCP's limit

/**
 * Scaffolder field extension that renders the Product Name input with a
 * dynamic character limit and a live preview of the final GCP project ID,
 * derived from the sibling `project_type` and `file_name` field values.
 */

export const ProductNameField = ({
    onChange,
    rawErrors,
    required,
    formData,
    formContext,
}: FieldExtensionComponentProps<string>) => {
    const siblingValues = formContext?.formData ?? {};
    const projectType = (siblingValues.project_type as string) || "dev";
    const businessUnit = (siblingValues.file_name as string) || "";

    // Empty product name yields just the "jh-<env>-<suffix>-" prefix.
    const prefix = buildProjectId(projectType, businessUnit, "");
    const maxProductNameLength = Math.max(
        MAX_PROJECT_ID_LENGTH - prefix.length,
        0
    );

    const currentValue = formData ?? "";
    const remaining = maxProductNameLength - currentValue.length;
    const previewId = buildProjectId(projectType, businessUnit, currentValue);

    const helperText =
        remaining >= 0
            ? `${remaining} character${remaining === 1 ? "" : "s"} remaining. `
            : `${Math.abs(remaining)} character${
                  Math.abs(remaining) === 1 ? "" : "s"
              } over limit! `;

    return (
        <TextField
            label="Product Name"
            description={`${helperText}Final Project ID will be: ${
                previewId || prefix
            }`}
            placeholder="Product Name"
            isRequired={required}
            isInvalid={(rawErrors?.length ?? 0) > 0 || remaining < 0}
            value={currentValue}
            maxLength={maxProductNameLength}
            onChange={value => onChange(value)}
        />
    );
};
